import { render } from "./AppMenuWorkspaceSelect.vue?vue&type=template&id=51bab2f0&scoped=true"
import script from "./AppMenuWorkspaceSelect.vue?vue&type=script&lang=js"
export * from "./AppMenuWorkspaceSelect.vue?vue&type=script&lang=js"

import "./AppMenuWorkspaceSelect.vue?vue&type=style&index=0&id=51bab2f0&lang=scss&scoped=true"
import "./AppMenuWorkspaceSelect.vue?vue&type=style&index=1&id=51bab2f0&lang=scss"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51bab2f0"]])

export default __exports__